module.exports = require('./dist/with-data-dependencies');
